import Vue from 'vue';

Vue.filter('numFormat', function (num) {
  return Number(num).toLocaleString()
})

Vue.filter('currencyFormatter', function (num) {
  let x = num
  let point = getPrecision(num);
  if (point <= 2) {
    point = 2;
  } else if (point == 3) {
    point = 3;
  } else if (point >= 4) {
    point = 4;
  }
  if (x === 0) {
    return "0.00"
  } else if (!x) {
    return x
  }
  return x.toFixed(point).replace(/\d(?=(\d{3})+\.)/g, "$&,")
})

Vue.filter('currencyFormatterWithSymbol', function (value, currency) {
  let point = getPrecision(value);
  try {
    if (point <= 2) {
      let libfrom = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: `${currency}`,
        maximumFractionDigits: 2,
        currencyDisplay: "narrowSymbol"
      });
      return libfrom.format(value);
    } else {
      let libfrom = new Intl.NumberFormat("th-TH", {
        style: "currency",
        currency: `${currency}`,
        maximumFractionDigits: 3,
        currencyDisplay: "narrowSymbol"
      });
      return libfrom.format(value);
    }
  } catch (error) {
    if (point <= 2) {
      return `${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${currency}`;
    } else {
      return `${value.toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${currency}`;
    }
  }
})

Vue.filter('currencySymbol', function (currencyCode) {
  try {
    const formatter = new Intl.NumberFormat("th-TH", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol"
    });

    const parts = formatter.formatToParts(1);

    // Find the part that is the currency symbol
    const currencyPart = parts.find(part => part.type === "currency");
    const currencySymbol = currencyPart ? currencyPart.value : currencyCode;

    return currencySymbol;
  } catch (error) {
    return `${currencyCode}`;
  }
})

Vue.filter('currencySymbol', function (currencyCode) {
  try {
    const formatter = new Intl.NumberFormat("th-TH", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol"
    });

    const parts = formatter.formatToParts(1);

    // Find the part that is the currency symbol
    const currencyPart = parts.find(part => part.type === "currency");
    const currencySymbol = currencyPart ? currencyPart.value : currencyCode;

    return currencySymbol;
  } catch (error) {
    return `${currencyCode}`;
  }
})

Vue.filter('commaFormatter', (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

Vue.filter('balanceFormatter', function (num) {
  let x = num
  if (x === 0) {
    return "0.00"
  } else if (!x) {
    return x
  }
  return x.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
})

Vue.filter('commaSeperate', function (num) {
  return String(num).replace(/\d(?=(\d{3})+\.)/g, "$&,")
})

Vue.filter('decimalFormat', function (value) {
  if (typeof value !== 'number') return value;
  value = Math.round((value + Number.EPSILON) * 10000) / 10000;
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
});

function getPrecision(num) {
  const round = Math.round((num + Number.EPSILON) * 10000) / 10000;
  const numberStr = round.toString();
  if (numberStr.includes('.')) {
    const parts = numberStr.split('.');
    const count = parts[1].length;
    if (count <= 1) return 2;
    else if (count >= 4) return 4;
    else return parts[1].length;
  } else return 2;
}

export default {
  formatter(unix) {
    let t = new Date(unix)
    const zeroPad = (value, size) => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value)
    return `${zeroPad(t.getDate(), 2)}/${zeroPad(
      t.getMonth() + 1, 2
    )}/${t.getFullYear()} ${zeroPad(t.getHours(), 2)}:${zeroPad(
      t.getMinutes(), 2
    )}:${zeroPad(t.getSeconds(), 2)}`
  },
  ipFormatter(ip) {
    const ipAddress =
      ip !== undefined
        ? ip
          .split(":")
          .slice(-1)
          .pop()
        : ""
    return ipAddress !== "1" ? ipAddress : "localhost"
  },
  getUserPersistent() {
    if (localStorage.getItem("ambgames-user-authenticate") === null) {
      return {
        user: {
          _id: null,
          username: null,
          role: null,
          source: null,
          avatar: null,
          profile: {
            name: null,
            mobile: null,
            lineId: null,
            gender: null,
            facebook: null,
            nickname: null,
          },
          wallet: {
            balance: null,
            buyIn: null,
            lastUpdate: null,
          },
          pt: {
            general: null,
            pg: null,
            ds: null,
          },
          level: null
        },
        token: null,
      }
    }
    return JSON.parse(localStorage.getItem("ambgames-user-authenticate"))
  },
  getUserBalance() {
    if (localStorage.getItem("ambgames-user-balance") === null) {
      return 0
    }
    return localStorage.getItem("ambgames-user-balance")
  },
  setUserBalance(balance) {
    localStorage.setItem('ambgames-user-balance', balance)
  },
  dateFormatter(unix) {
    let t = new Date(unix)
    const zeroPad = (value, size) => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value)
    return `${zeroPad(t.getFullYear(), 2)}-${zeroPad(t.getMonth() + 1, 2)}-${zeroPad(t.getDate(), 2)}`
  },
  dateTimeFormatter(unix) {
    let t = new Date(unix)
    const zeroPad = (value, size) => (String(value).length < size ? zeroPad(`0${String(value)}`, size) : value)
    return `${zeroPad(t.getFullYear(), 2)}-${zeroPad(t.getMonth() + 1, 2)}-${zeroPad(t.getDate(), 2)} ${zeroPad(t.getHours(), 2)}:${zeroPad(t.getMinutes(), 2)}:${zeroPad(t.getSeconds(), 2)}`
  },
  getTokenData(token) {
    const userdataJSON = token.split('.')[1];
    if (!userdataJSON) return '';
    const base64 = userdataJSON.replace(/-/g, '+').replace(/_/g, '/');
    const objJsonB64 = atob(base64);
    if (!objJsonB64 || objJsonB64.length === 0) return '';

    const data = JSON.parse(objJsonB64.trim());
    return data;
  }
}
